import { useContext, useState, useEffect } from "react";
import { collection, addDoc, getFirestore } from "firebase/firestore";
import CartContext from "../../context/CartContext";
import CheckOutForm from "../CheckOutForm/CheckOutForm";
import "./CheckOut.css";

const CheckOut = () => {
  const [cargando, setCargando] = useState(false);
  const [ordenId, setOrdenId] = useState("");
  const [totalReal, setTotalReal] = useState(0);

  const { cart, clear } = useContext(CartContext);

  useEffect(() => {
    setTotalReal(calcularTotal(cart));
  }, [cart]);

  const sendOrder = async ({ name, phone, email }) => {
    setCargando(true);
    try {
      const order = {
        buyer: {
          name,
          phone,
          email,
        },
        items: cart,
        total: totalReal,
      };
      const db = getFirestore();
      const orderCollectionRef = collection(db, "orders");
      await addDoc(orderCollectionRef, order)
        .then((docRef) => {
          console.log("Orden con ID " + docRef.id + " creada!");
          setOrdenId(docRef.id);
          clear(); // Limpiar el carrito después de guardar la orden
        })
        .catch((error) => {
          console.error("Error al crear la orden:", error);
        });
    } finally {
      setCargando(false);
    }
  };

  const calcularTotal = (cart) => {
    let total = 0;
    cart.forEach((item) => {
      total += item.precio * item.cantidad;
    });
    return total;
  };

  if (cargando) {
    return (
      <div className="checkout-status loading-order">
        Procesando tu orden…
      </div>
    );
  }

  if (ordenId) {
    return (
      <div className="checkout-status">
        <p className="order-number mb-2">Tu número de orden: {ordenId}</p>
        <p className="thank-you mb-0">Gracias por elegir X-treme Shop.</p>
      </div>
    );
  }

  return (
    <div>
      <CheckOutForm onConfirm={sendOrder} />
    </div>
  );
};

export default CheckOut;



